export const CORE_HOTELS_CFAR_NAME = "core-hotels-cfar";

export enum CoreHotelCfarOffersComponents {
  LodgingCfarOfferSection = "LodgingCfarOfferSection",
  LodgingCfarHowItWorksDialog = "LodgingCfarHowItWorksDialog",
  LodgingCfarFintechMarketplaceProduct = "LodgingCfarFintechMarketplaceProduct",
  HtsLodgingCfarFintechMarketplaceProduct = "HtsLodgingCfarFintechMarketplaceProduct",
  LodgingCancellationPolicyContentItem = "LodgingCancellationPolicyContentItem",
  LodgingCfarCheckoutPolicyDisclaimer = "LodgingCfarCheckoutPolicyDisclaimer",
  LodgingCfarSyntheticRateBase = "LodgingCfarSyntheticRateBase",
  LodgingSyntheticRateFullyRefundable = "LodgingSyntheticRateFullyRefundable",
  LodgingSyntheticRatePartiallyRefundable = "LodgingSyntheticRatePartiallyRefundable",
  LodgingSyntheticRateNegativePremium = "LodgingSyntheticRateNegativePremium",
  CfarFullyRefundableModal = "CfarFullyRefundableModal",
  CfarFullyRefundableInfoIcon = "CfarFullyRefundableInfoIcon",
}

export enum CoreHotelsCfarExerciseComponents {
  LodgingCfarExerciseGenericActionView = "LodgingCfarExerciseGenericActionView",
  LodgingCfarExerciseErrorExpired = "LodgingCfarExerciseErrorExpired",
  LodgingCfarExerciseErrorExercised = "LodgingCfarExerciseErrorExercised",
  LodgingCfarExerciseErrorUnknown = "LodgingCfarExerciseErrorUnknown",
  LodgingCfarExerciseErrorVoid = "LodgingCfarExerciseErrorVoid",
  LodgingCfarExerciseComplete = "LodgingCfarExerciseComplete",
  LodgingCfarExerciseLoadingScreen = "LodgingCfarExerciseLoadingScreen",
  LodgingCfarExerciseConfirmCancellation = "LodgingCfarExerciseConfirmCancellation",
  LodgingCfarExerciseNavWrapper = "LodgingCfarExerciseNavWrapper",
  LodgingCfarExercise = "LodgingCfarExercise",
  LodgingCfarExercisePage = "LodgingCfarExercisePage",
  HtsLodgingCfarExerciseContent = "HtsLodgingCfarExerciseContent",
  HtsLodgingCfarNonExercisableContent = "HtsLodgingCfarNonExercisableContent",
  HtsLodgingCfarExerciseActionButtons = "HtsLodgingCfarExerciseActionButtons",
}
